import { message } from 'antd';
import { config } from "util/config";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

//选Copy Owner Details时赋值当前job的Owner的值
export function copyOwnerDetails({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let jobContactComponent = globalFunction.getSectionComponent(pageComponent, 'JobContact');
  if (jobContactComponent !== null) {
    let owners = jobContactComponent.child.current?.state.data.filter(item => item.ContactTypeName === 'Owner');
    if (owners.length > 0) {
      formComponent.formRef.current?.setFieldValue('OwnerName', owners[0].FullNameCompany);
      formComponent.formRef.current?.setFieldValue('ContactNumber', owners[0].ContactNumber);
      formComponent.formRef.current?.setFieldValue('Email', owners[0].Email);

      formComponent.formRef.current?.setFieldValue('PostalStreetNumber', owners[0].PostalStreetNumber);
      formComponent.formRef.current?.setFieldValue('PostalStreetName', owners[0].PostalStreetName);
      formComponent.formRef.current?.setFieldValue('PostalSuburb', owners[0].PostalSuburb);
      formComponent.formRef.current?.setFieldValue('PostalPostcode', owners[0].PostalPostcode);
      formComponent.formRef.current?.setFieldValue('PostalState', owners[0].PostalState);
      formComponent.formRef.current?.setFieldValue('PostalCountry', owners[0].PostalCountry);
    }
  }
}

//选Copy Site Details时给Address赋值当前job的Property的值
export function copySiteDetails({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    formComponent.formRef.current?.setFieldValue('PptStreetNumber', pageComponent.state.jobData.PptStreetNumber);
    formComponent.formRef.current?.setFieldValue('PptStreetName', pageComponent.state.jobData.PptStreetName);
    formComponent.formRef.current?.setFieldValue('PptSuburb', pageComponent.state.jobData.PptSuburb);
    formComponent.formRef.current?.setFieldValue('PptState', pageComponent.state.jobData.PptState);
    formComponent.formRef.current?.setFieldValue('PptPostcode', pageComponent.state.jobData.PptPostcode);
    formComponent.formRef.current?.setFieldValue('PptLot', pageComponent.state.jobData.PptLot);
    formComponent.formRef.current?.setFieldValue('PptCounty', pageComponent.state.jobData.PptCounty);
    formComponent.formRef.current?.setFieldValue('PptFolio', pageComponent.state.jobData.PptFolio);
    formComponent.formRef.current?.setFieldValue('PptLpps', pageComponent.state.jobData.PptLpps);
    formComponent.formRef.current?.setFieldValue('PptVolume', pageComponent.state.jobData.PptVolume);
    formComponent.formRef.current?.setFieldValue('PptSection', pageComponent.state.jobData.PptSection);
    formComponent.formRef.current?.setFieldValue('PptParish', pageComponent.state.jobData.PptParish);
    formComponent.formRef.current?.setFieldValue('PptCrownAllotment', pageComponent.state.jobData.PptCrownAllotment);
  } else {
    formComponent.formRef.current?.setFieldValue('PptStreetNumber', '');
    formComponent.formRef.current?.setFieldValue('PptStreetName', '');
    formComponent.formRef.current?.setFieldValue('PptSuburb', '');
    formComponent.formRef.current?.setFieldValue('PptState', '');
    formComponent.formRef.current?.setFieldValue('PptPostcode', '');
    formComponent.formRef.current?.setFieldValue('PptLot', '');
    formComponent.formRef.current?.setFieldValue('PptCounty', '');
    formComponent.formRef.current?.setFieldValue('PptFolio', '');
    formComponent.formRef.current?.setFieldValue('PptLpps', '');
    formComponent.formRef.current?.setFieldValue('PptVolume', '');
    formComponent.formRef.current?.setFieldValue('PptSection', '');
    formComponent.formRef.current?.setFieldValue('PptParish', '');
    formComponent.formRef.current?.setFieldValue('PptCrownAllotment', '');
  }
}

//Property Suburb 选择后回填房产地址的 Suburb 和 Postcode
export function searchSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter?.data === null || parameter?.data === undefined) {
    return;
  }

  formComponent.formRef.current?.setFieldsValue({
    PptSuburb: parameter.data.Name,
    PptPostcode: parameter.data.Postcode
  });
}

export function updateCombinedAllotmentDetermination({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  pageComponent.setState({ updateCombinedAllotmentDeterminationShow: true });
  setTimeout(() => {
    pageComponent.updateCombinedAllotmentDeterminationInfo.current?.getCombinedAllotmentDeterminationTemplateDataSource();
  }, config.setTimeoutMilliSecond);
}
